import {
  Paginated,
  PaymentHistoryFilters,
  Sortable,
} from "@ac-expo/api-types";

export const paymentHistoryQueryKeys = {
  all: ["paymentHistory"] as const,
  lists: (filters: Sortable<Paginated<PaymentHistoryFilters>>) =>
    [...paymentHistoryQueryKeys.all, filters] as const,
};

export default paymentHistoryQueryKeys;
